<script setup>
import { computed } from 'vue';
const { strong } = defineProps({
  // Use strong prop when this dropdown is stacked inside another dropdown
  // Stacked dropdowns should keep a stronger border so nested menus stay legible.
  strong: {
    type: Boolean,
    default: false,
  },
});

const borderClass = computed(() => {
  return strong ? 'border-n-strong' : 'border-n-weak';
});

const beforeClass = computed(() => {
  if (!strong) return '';

  return "before:content-['\x00A0'] before:absolute before:bottom-0 before:left-0 before:w-full before:h-full before:rounded-xl before:bg-n-brand/5 before:z-0 [&>*]:relative";
});
</script>

<template>
  <div class="absolute">
    <ul
      class="n-dropdown-body reset-base relative grid list-none gap-2 rounded-xl border bg-n-background px-2 py-2 text-sm shadow-xl"
      :class="[borderClass, beforeClass]"
    >
      <slot />
    </ul>
  </div>
</template>
